module.exports = __webpack_public_path__ + "static/media/no_retreat_120.a9fc38ed.png";